import { createSelector } from "reselect"
import { omit, map } from "lodash"

export const getData = props => props.data

export const getTotalData = createSelector(
  [getData],
  (data) => map(data, ({ positionsCount, index, date }) => ({
    positionsCount,
    index,
    date,
  })),
)

export const getBreakdownData = createSelector(
  [getData],
  (data) => {
    return map(data, item => omit(item, "positionsCount"))
  },
)
